// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2YAo0","title":"Header_title__JlV13","left":"Header_left__3RMmz","clinicName":"Header_clinicName__M3loa"};